const config = {
  entity_short_name: "ZACD",
  baseurl_override: undefined,
  // ZACD brand addresses TBD — use Alta Postmark-verified senders for staging smoke (AG-7281)
  email: {
    generic: "enquiry@alta.exchange",
    doNotReply: "no-reply@alta.exchange",
    operations: "operations@alta.exchange",
    cs: "cs@alta.exchange",
    clientSuccess: "clientsuccess@alta.exchange",
    settlements: {
      sg: "settlements@alta.exchange",
      my: "settlement.my@alta.exchange",
    },
    onboarding: "investor.onboarding@alta.exchange",
    kyc: {
      my: "ecf-kyc@alta.exchange",
    },
    compliance: "compliance@alta.exchange",
    internal: {
      legalAndCompliance: "lc@alta.exchange",
      compliance: "prime-kyc@alta.exchange",
      pcm: "pcm@alta.exchange",
    },
    trustee: "operation@pacifictrustees.com",
  },
  entity_legal_url: "https://zacd.placeholder/terms-of-use",
  entity_help_url: "https://help.alta.exchange/investor-resources",
  branding: {
    asset: {
      logoPublicUrl: "",
    },
    fontSize: {
      "2xs": "0.625rem",
      xs: "0.75rem",
      sm: "0.875rem",
      base: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "2rem",
      "4xl": "2.25rem",
    },
    colors: {
      brand: {
        primary: "#44ADDD",
        "primary-hover": "#2E8FB8",
        secondary: "#2E2F60",
        "secondary-hover": "#232448",
        accent: {
          1: "#C1E9F5",
          2: "#5C0F8B",
          3: "#C1E9F5",
          4: "#5C0F8B",
        },
        email: "#2E2F60",
        "platform-background": "#2E2F60",
      },
      white: "#ffffff",
      black: "#161618",
      gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
      },
      forest: {
        50: "#fcfdfd",
        100: "#f5fbfc",
        200: "#daeaed",
        300: "#bdd4d9",
        400: "#90b3bb",
        500: "#2c5862",
        600: "#17434d",
        700: "#073a45",
        800: "#00313c",
        900: "#05262e",
      },
      red: {
        50: "#fffafa",
        100: "#fff0f1",
        200: "#f5d5d8",
        300: "#f5b5ba",
        400: "#f16974",
        600: "#af1623",
        800: "#681219",
        500: "#d93f4c",
        700: "#8c232c",
        900: "#570f15",
      },
      orange: {
        50: "#fffaf5",
        100: "#fff7ed",
        200: "#ffeedb",
        300: "#fed6a8",
        400: "#ffb057",
        500: "#f79a3e",
        600: "#ed8f1c",
        700: "#ad5918",
        800: "#703815",
        900: "#5e2f12",
      },
      green: {
        50: "#f8fcfb",
        100: "#edf8f4",
        200: "#d1e8df",
        300: "#aecfc2",
        400: "#5eae91",
        500: "#228f67",
        600: "#038153",
        700: "#186146",
        800: "#0b3b29",
        900: "#092f21",
      },
      blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
      },
    },
  },

  allowViewOnlyInternalLogins: false,
  internalUserDomain: null,

  services: {
    platforms: ["SG"],
    "a-prime": {
      enabled: true,
      intercom: false,
      showOverlaysOnAPrimeAuthPage: false,
      integrations: {
        calendly: { enabled: false },
        googleAds: { enabled: false },
        googleAnalytics: { enabled: false },
        googleTagManager: { enabled: false },
        hubspot: { enabled: false },
        linkedinInsights: { enabled: false },
        recaptcha: { enabled: false },
        segment: { enabled: false },
        sentry: { enabled: false },
        singpass: { enabled: false },
      },
      disclaimer: {
        copy: `**Risk Warning & Disclaimers** ZACD offers investment opportunities through this platform. This website has not been reviewed by any regulatory authority and has been prepared solely for informational purposes. Investing in private companies carries significant risks including illiquidity, loss of capital, rarity of dividends, and dilution. Investors should seek their own professional advice before investing.`,
      },
      unitedStatesPersonDefinitionLink:
        "https://help.alta.exchange/investor-resources/what-is-a-united-states-person",
      politicallyExposedPersonDefinitionLink:
        "https://help.alta.exchange/investor-resources/what-does-a-politically-exposed-person-pep-mean",
      usPersonDefinitionLink:
        "https://help.alta.exchange/investor-resources/what-is-a-united-states-person",
      riskDisclosure: {
        link: "https://zacd.placeholder/risk-disclosures",
      },
      features: {
        ecf: { enabled: false },
        hardcodeHamiltonHoldings: { enabled: false },
        marketingOptIn: { enabled: false },
        paymentRef: { enabled: false },
        pricingGraph: { enabled: true },
        primaryFirmDeal: { enabled: false },
        topPicks: { enabled: false },
        raiseCapital: { enabled: false, externalUrl: "#" },
        portfolio: {
          enabled: true,
          orderStatusUrl: "https://help.alta.exchange/order-statuses-sg",
        },
        mmf: { enabled: false, externalUrl: "#", yield: "X.XX%" },
        singpassNoa: { enabled: false },
        idenfy: { enabled: true },
        partner: { enabled: false },
      },
    },
    atlas: {
      authentication: {
        provider: "credentials",
        superAdminEmails: [],
      },
      features: {
        superadmin: {
          enabled: true,
          modules: {
            beneficiaryOwner: false,
            singpass: false,
            topPicks: false,
            "finance.bankLedger": false,
            "finance.withdrawalApproval": false,
            "investor.cashBalance": false,
            "product.assets.listOnExchange": false,
            "product.deals.dealFee": false,
            "product.deals.investmentConfig": false,
            "product.deals.updateGraph": false,
            "product.deals.exchangeCode": false,
            "product.deals.partner": false,
            mmf: false,
          },
          formOptions: {
            deals: {
              listingType: { omit: ["secondary"] },
              orderType: { omit: ["firm_order"] },
            },
            orders: {
              createType: { omit: ["issue"] },
            },
          },
        },
        idenfy: { enabled: true },
        backendOrdersExport: { enabled: false },
      },
    },
  },

  paymentMethod: {
    displayPaymentMethod: true,
    sendPaymentMethodEmail: true,
    paymentMethodText: "Bank transfer",
    paymentMethodLink: "https://help.alta.exchange/how-do-i-fund-my-account",
    primaryFirmPaymentInformation: {
      accountName: "TBD",
      uen: "TBD",
      accountNumber: "TBD",
      bankName: "TBD",
      bankCode: "TBD",
      branchName: "TBD",
      branchCode: "TBD",
      swiftCode: "TBD",
      paynowQRUrl: "",
    },
  },

  bankInformation: {
    sg: {
      accountName: "TBD",
      uen: "TBD",
      accountNumber: "TBD",
      bankName: "TBD",
      bankCode: "TBD",
      branchName: "TBD",
      branchCode: "TBD",
      swiftCode: "TBD",
      paynowQRUrl: "",
    },
    my: {
      beneficiaryName: "NA",
      beneficiaryAddress: "NA",
      bankName: "NA",
      bankBranch: "NA",
      swiftCode: "NA",
      accountType: "NA",
      accountNumber: "NA",
      bankCountryCity: "NA",
      bankAddress: "NA",
    },
  },
  custodySyncTncType: "sg-custody-tnc",
};

export default config;
